module.exports = __webpack_public_path__ + "media/images/it/logo-qualify-ce07d20a2227cd931c5d448554349f77.png";